// extracted by mini-css-extract-plugin
export default {"login-wrapper":"Login_login-wrapper__Ax1mN","login-title":"Login_login-title__AWPof"};